import ReactGA from 'react-ga4';

export const clickToAffiliateParkGA = (url) => {
  const site = url ? url?.split('.')?.[1] : 'External';
  const visitingSite = `${site.charAt(0).toUpperCase() + site.slice(1)}'s`;

  ReactGA.event('affiliate_park_click', {
    action: 'Clicked link to affiliate park',
    operator: visitingSite,
  });
};

export const switchedToResultsMapViewGA = () => {
  ReactGA.event('switched_to_results_map_view', {
    action: 'Switched to results map view',
  });
};

export const switchedToParkMapViewGA = (park) => {
  ReactGA.event('switched_to_park_map_view', {
    action: 'Switched to park map view',
    parkName: park.name,
    parkId: park.parkId,
  });
};

export const emailSignUpGA = (origin) => {
  ReactGA.event('email_sign_up', {
    action: 'Signed up to email',
    source: origin,
  });
};

export const searchResultsSortingGA = (sortBy) => {
  ReactGA.event('search_results_sorting', {
    action: 'Search results sorting',
    sortBy,
  });
};

export const searchResultsFilteringGA = (filterBy, toggle, value) => {
  ReactGA.event('search_results_filtering', {
    action: 'Search results filtering',
    filterBy,
    ...(toggle !== undefined && { toggle }),
    ...(value !== undefined && { value }),
  });
};

export const datesSliderChangedGA = (date) => {
  ReactGA.event('dates_slider_changed', {
    action: 'Dates slider changed',
    date: date.toDateString(),
  });
};

export const searchFormSubmitGA = (params) => {
  const { adults, arrivalDate, channelId, children, duration, parkId, petFriendly, regionId, under5s } = params;
  ReactGA.event('search_form_submit', {
    action: 'Search from submit',
    adults,
    arrivalDate: new Date(arrivalDate).toDateString(),
    channelId,
    children,
    duration,
    petFriendly,
    regionId,
    under5s,
    ...(parkId !== undefined && { parkId }),
  });
};

export const paymentCompleteGA = (bookingId, paymentAmount, park, extras, party) => {
  const extrasFormatted = extras.map(({ name, value, cost, totalCost }) => ({ name, value, cost, totalCost }));
  const { adults, children, under5s: infants, partySize, petFriendly } = party;

  ReactGA.gtag('event', 'purchase', {
    transaction_id: bookingId,
    value: paymentAmount,
    currency: 'GBP',
    items: [
      {
        item_id: park.name,
        item_name: park.name,
        item_region: park.regn,
        item_adults: adults,
        item_children: children,
        item_infants: infants,
        item_party_size: partySize,
        item_pet_friendly: petFriendly,
        price: paymentAmount,
        quantity: 1,
        google_business_vertical: 'retail',
        id: bookingId,
      },
      ...extrasFormatted.map((extra) => ({
        item_name: extra.name,
        item_cost: extra.cost,
        price: extra.totalCost,
        quantity: extra.value,
        google_business_vertical: 'retail',
      })),
    ],
  });
};

export const paymentErrorGA = (message, status) => {
  ReactGA.event('payment_error', {
    action: 'Payment Error',
    message,
    status,
  });
};

export const externalLinkGA = (destination) => {
  ReactGA.event('external_link_click', {
    action: 'External link click',
    destination,
  });
};

export const errorMessageGA = (errorMessage) => {
  ReactGA.event('error_message', {
    action: 'Error message',
    errorMessage,
    page: window.location.pathname,
  });
};
